import React from "react";
import MUIDataTable from "mui-datatables";
import { Container } from "reactstrap";
import EmailAccountsAddFormForm from "./EmailAccountsAddForm";
import Grid from "@material-ui/core/Grid";
import EmailsAccountsUpdateFormForm from "./EmailsAccountsUpdateForm";
import Moment from "react-moment";

class EmailAccountsDataTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: props.data,
    };
  }

  render() {
    const columns = [
      {
        name: "emailAccountName",
        label: "Display Name",
        options: {
          filter: false,
        },
      },
      {
        name: "emailAccountEmail",
        label: "Account Email",
        options: {
          filter: true,
        },
      },
      {
        name: "emailAccountCreateDate",
        label: "Created Date",
        options: {
          filter: true,
          customBodyRender: (value) => {
            return <Moment format="MMMM Do YYYY, h:mm a">{value}</Moment>;
          },
        },
      },
      {
        name: "emailAccountLastUpdateDate",
        label: "Updated Date",
        options: {
          filter: true,
          customBodyRender: (value) => {
            return <Moment format="MMMM Do YYYY, h:mm a">{value}</Moment>;
          },
        },
      },

      {
        name: "UserModifiedFullName",
        label: "Modified by",
        options: {
          filter: true,
        },
      },

      {
        name: "emailAccountId",
        label: "Update",
        options: {
          filter: false,
          customBodyRender: (value) => {
            return <EmailsAccountsUpdateFormForm id={value} />;
          },
        },
      },
    ];

    const data = this.state.items;

    const options = {
      filter: true,
      selectableRows: "none",
      selectableRowsOnClick: false,
      filterType: "multiselect",
      responsive: "stacked",
      viewColumns: false,
      rowsPerPage: 10,
      rowsPerPageOptions: [5, 10, 15, 100],
    };

    return (
      <Container>
        <Grid
          container
          direction="row"
          justify="flex-end"
          alignItems="center"
          spacing={2}
          style={{ padding: 20 }}
        >
          <Grid item>
            <EmailAccountsAddFormForm />
          </Grid>
        </Grid>

        <Container fluid>
          <MUIDataTable
            title={"Search by name"}
            data={data}
            columns={columns}
            options={options}
          />
        </Container>
      </Container>
    );
  }

  
}

export default EmailAccountsDataTable;
